module.exports = __webpack_public_path__ + "img/ИФ-1(А)-002.ecc508c0.png";